import Logout from "./logout-view";
export default Logout;
